import React from 'react';

const ConditionalIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.75 6.37197C11.6239 6.06309 12.25 5.22966 12.25 4.25C12.25 3.00736 11.2426 2 10 2C8.75736 2 7.75 3.00736 7.75 4.25C7.75 5.22966 8.37611 6.06309 9.25 6.37197V9.25H4.25C3.83579 9.25 3.5 9.58579 3.5 10V13.5C3.5 13.5424 3.50352 13.584 3.51028 13.6244C2.63102 13.9304 2 14.7665 2 15.75C2 16.9926 3.00736 18 4.25 18C5.49264 18 6.5 16.9926 6.5 15.75C6.5 14.7665 5.86898 13.9304 4.98972 13.6244C4.99648 13.584 5 13.5424 5 13.5V10.75H15V13.5C15 13.5424 15.0035 13.584 15.0103 13.6244C14.131 13.9304 13.5 14.7665 13.5 15.75C13.5 16.9926 14.5074 18 15.75 18C16.9926 18 18 16.9926 18 15.75C18 14.7665 17.369 13.9304 16.4897 13.6244C16.4965 13.584 16.5 13.5424 16.5 13.5V10C16.5 9.58579 16.1642 9.25 15.75 9.25H10.75V6.37197Z"
        fill="#1b1ec6" 
      />
    </svg>
  );
};

export default ConditionalIcon;
